import { SxProps, Theme } from '@mui/material';

export const nIcon = (size: 'sm' | 'md'): SxProps<Theme> => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  padding: 0,
  margin: 0,
  height: size === 'sm' ? '16px' : '24px',
  width: size === 'sm' ? '16px' : '24px',
  minWidth: size === 'sm' ? '16px' : '24px',
  '& svg': {
    display: 'block',
    height: '100%',
    width: '100%'
  }
});
